<template lang="pug">
  .pacientes-container
    modal-paciente(:openModal="modal", @close="closeModal", :edicao="pacientesEdicao", @atualiza="atualizaLista")
    .pacientes-conteudo
      .filtro
        .filtros
          el-badge.item(:value="checkListGeral.length", :hidden="!checkListGeral.length ? true : false")
            el-button(round, @click="abreFiltrosGerais") Filtros
              i(class="fa fa-filter")
          .filtros-gerais(v-if="filtrosGerais")
            .topo-filtro-gerais
              span Filtros
              span(@click.stop="recarrega") {{ `Limpar (${checkListGeral.length})` }}
            .corpo
              el-checkbox-group(v-model="checkListGeral", class="filter", @change="filtro")
                .div
                  img(src="../../assets/paciente.svg")
                  el-checkbox(label="Ativos")
                .div
                  img(src="../../assets/paciente.svg")
                  el-checkbox(label="Inativos")
                .div
                  img(src="../../assets/paciente.svg")
                  el-checkbox(label="Femininos")
                .div
                  img(src="../../assets/paciente.svg")
                  el-checkbox(label="Masculinos")
            .footer(@click.stop="filtrosGerais = !filtrosGerais") {{ `Ver ${qtdPacientes} resultados` }}
        .ordenacao
          el-button(round, @click.stop="abreFiltroOrdenacao") Ordenar
            i(class="fa fa-chevron-down")
          .filtros-ordenacao(v-if="filtrosOrdernacao")
            .topo-filtro-ordenacao
              span Ordenar
              span(@click.stop="checkListOrdenacao = ''")
            .corpo
              el-radio-group(v-model="checkListOrdenacao", class="order", @change="ordem")
                .div
                  img(src="../../assets/paciente.svg")
                  el-radio(label='ascendente') De A-Z
                .div
                  img(src="../../assets/paciente.svg")
                  el-radio(label='descendente') De Z-A
                .div
                  img(src="../../assets/paciente.svg")
                  el-radio(label='novos') Mais Novos Primeiro
                .div
                  img(src="../../assets/paciente.svg")
                  el-radio(label='velhos') Mais Velhos Primeiro
            .footer(@click.stop="filtrosOrdernacao = !filtrosOrdernacao") {{ `Ver ${qtdPacientes} resultados` }}
        .busca
          el-input(placeholder="Buscar...", prefix-icon="fa fa-search", v-debounce:500ms="buscaPorNome", v-model="buscaTexto")
      .sem-cadastro(v-if="!this.pacientes.lista || !this.pacientes.lista.length") Nenhum paciente cadastrado!
      ul.corpo-lista(v-else)
        li.lista(@click="abreModalEditar(list)", v-for="(list, a) in pacientes.lista", :key="a", :class="[list.status === 'I' ? 'inativo' : '']")
          .icn
            img(v-if="list.status === 'A'", src="../../assets/paciente.svg")
            img(v-else, src="../../assets/paciente-inativos.svg")
          .info
            .nome-paciente {{ list.nome }}
            .dados-paciente
              .cpf {{ list.cpf || list.documento }} -
              .nascimento {{ list.data_nascimento | mascaraDN }},
              .genero {{ list.genero === 'M' ? 'Masculino' : 'Feminino' }},
              .email {{ list.email }},
              .telefone {{ list.telefone | mascaraFone }}
          .acao
            i(class="fa fa-pencil", aria-hidden="true")
      .paginacao
        el-pagination(layout="prev, pager, next", prev-text="Anterior", next-text="Próximo", :total="Number(qtdPacientes)", @current-change="handleCurrentChange", v-if="Number(qtdPacientes) > 10")
</template>

<script>
import ModalPaciente from './ModalPaciente'
import Services from '../../utils/services'
import { mapGetters, mapMutations } from 'vuex'
import moment from 'moment'
moment.locale('pt-BR')

export default {
  components: { ModalPaciente },

  created() {
    this.getPacientes()
  },

  data: () => ({
    modal: false,
    filtrosGerais: false,
    filtrosOrdernacao: false,
    pacientes: [],
    page: 0,
    size: 10,
    qtdPacientes: 0,
    pacientesEdicao: '',
    checkListGeral: [],
    checkListOrdenacao: '',
    status: [],
    genero: [],
    tipoOrdem: '',
    campoOrdem: '',
    multi: '',
    buscaTexto: ''
  }),
  filters:{
    mascaraDN(dn){
      return moment(dn).format('L')
    },
    mascaraFone(cel){
      return cel.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3")
    }
  },
  computed: {
    ...mapGetters(['getModal'])
  },
  watch: {
    getModal(){
      if(this.getModal === 'Pacientes') this.abreModalCadastrar()
    }
  },
  methods: {
    ...mapMutations(['setLoad', 'setModal']),

    /* Metodo que lista os Pacientes */
    async getPacientes(){
      this.setLoad(true)
      this.pacientes = await Services.get(`/paciente/listar/${this.size}/pular/${this.page*10}`, { tipoOrdem: this.tipoOrdem, campoOrdem: this.campoOrdem})
      console.log(this.pacientes)
      if(this.pacientes.lista) {
        this.qtdPacientes = this.pacientes.quantidade[0].quantidade
        this.setLoad(false)
      }
    },

    /* Metodo que abre o modal de um novo cadastro */
    abreModalCadastrar(){
      this.modal = true
    },

    /* Metodo que abre o modal de edição */
    abreModalEditar(list) {
      this.modal = true
      this.pacientesEdicao = list
    },

    /* Metodo que abre Filtros Gerais */
    abreFiltrosGerais(){
      this.filtrosGerais = !this.filtrosGerais
      this.filtrosOrdernacao = false
    },

    /* Metodo que recarrega lista ao limpar os filtros */
    recarrega(){
      this.checkListGeral = []
      this.getPacientes()
    },

    /* Metodo que faz requisicao de filtro */
    async filtro(e){
      this.setLoad(true)
      this.status = []
      this.genero = []
      console.log(e)
      if(e.length){
        e.find(e => {
          if(e === 'Ativos') this.status.push('A')
          if(e === 'Inativos') this.status.push('I')
          if(e === 'Femininos') this.genero.push('F')
          if(e === 'Masculinos') this.genero.push('M')
        })
        
        if(this.status.length){
          this.multi = JSON.stringify([{
            status: this.status
          }])
        }
        if(this.genero.length){
          this.multi = JSON.stringify([{
            genero: this.genero
          }])
        }
        if(this.status.length && this.genero.length){
          this.multi = JSON.stringify([{
            status: this.status,
            genero: this.genero
          }])
        }
        let pacientes = await Services.get(`/paciente/listar/${this.size}/pular/${this.page*10}`, { tipoOrdem: this.tipoOrdem, campoOrdem: this.campoOrdem, multiFiltro: this.multi })
        this.pacientes = pacientes
        this.qtdPacientes = pacientes.quantidade[0].quantidade
        this.setLoad(false)
        if(this.page > 0) this.page = 0
      }else{
        this.getPacientes()
      }
    },

    /* Metodo que abre Filtros de Ordenação */
    abreFiltroOrdenacao(){
      this.filtrosOrdernacao = !this.filtrosOrdernacao
      this.filtrosGerais = false
    },

    /* Metodo que faz requisicao de ordenacao */
    async ordem(e){
      this.setLoad(true)
      if(e === 'ascendente'){
        this.tipoOrdem = 'ascendente'
        this.campoOrdem = 'nome'
      }
      if(e === 'descendente'){
        this.tipoOrdem = 'descendente'
        this.campoOrdem = 'nome'
      }
      if(e === 'novos'){
        this.tipoOrdem = 'descendente'
        this.campoOrdem = 'data_nascimento'
      }
      if(e === 'velhos'){
        this.tipoOrdem = 'ascendente'
        this.campoOrdem = 'data_nascimento'
      }
      
      this.pacientes = await Services.get(`/paciente/listar/${this.size}/pular/${this.page*10}`, { tipoOrdem: this.tipoOrdem, campoOrdem: this.campoOrdem, multiFiltro: this.multi })
      this.qtdPacientes = this.pacientes.quantidade[0].quantidade
      this.setLoad(false)
    },

    /* Metodo que busca nome do paciente atraves do campo de testo */
    async buscaPorNome(){
      if(this.buscaTexto.length > 2){
        this.setLoad(true)
        this.pacientes = await Services.get(`/paciente/${this.buscaTexto}`)
        console.log('Busca Por nome pelo campo de texto', this.pacientes)
        if(this.pacientes.quantidade) this.qtdPacientes = this.pacientes.quantidade[0].quantidade
        this.setLoad(false)
      }else{
        this.getPacientes()
      }
    },

    /* Metodo que atualiza a lista de pacientes quando houver sucesso no cadastro ou edicao */
    atualizaLista(){
      this.getPacientes()
    },

    /* Metodo que fecha o modal */
    closeModal(){
      this.modal = false
      this.setModal('')
      this.pacientesEdicao = ''
    },

    /* Métodos de paginação */
    handleCurrentChange(val) {
      this.page = val - 1
      if(!this.status.length && !this.genero.length) this.getPacientes()
      else{
        console.log('pagina',this.page)
        this.filtro(this.checkListGeral)
      }
    }
  }
}
</script>

<style lang="scss">
.pacientes-container{
  width: 1100px;
  height: calc(100% - 120px);
  margin: 0 auto;
  overflow: auto;
  
  &::-webkit-scrollbar {
    display: none;
  }

  .pacientes-conteudo{
    .filtro{
      margin-top: 25px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .filtros, .ordenacao{
        width: 140px;
        height: 55px;
        position: relative;

        .filtros-gerais, .filtros-ordenacao{
          position: absolute;
          width: 350px;
          height: 480px;
          box-shadow: 0 3px 6px rgba(0,0,0,.3);
          background: #fff;
          border: 1px solid #E9E9E9;
          border-radius: 10px;
          left: 0;
          top: 70px;
          padding: 35px;
          box-sizing: border-box;

          &::before{
            position: absolute;
            content: "";
            width: 15px;
            height: 15px;
            border-top: 1px solid #E9E9E9;
            border-right: 1px solid #E9E9E9;
            top: -8px;
            left: 45px;
            background: #fff;
            transform: rotate(-45deg);
            box-shadow: 1px -1px 1px rgba(0,0,0,.1);
          }

          .topo-filtro-gerais, .topo-filtro-ordenacao{
            display: flex;
            align-items: center;
            justify-content: space-between;

            span:first-child{
              color: #000;
              font-weight: 400;
              font-size: 23px;
            }
            span:last-child{
              color: #0180FF;
              font-weight: 400;
              font-size: 17px;
              cursor: pointer;
            }
          }
          .corpo{
            .el-checkbox-group.filter, .el-radio-group.order{
              width: 100%;

              .div{
                width: 100%;
                display: flex;
                border-bottom: 1px solid #E9E9E9;
                padding: 20px 0;

                &:first-child{
                  margin-top: 30px;
                }

                img{
                  width: 30px;
                  margin-right: 25px;
                }
                .el-checkbox, .el-radio{
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  flex-direction: row-reverse;
                  flex: 1;

                  .el-checkbox__label, .el-radio__label{
                    color: #000;
                    font-size: 18px;
                    font-weight: 300;
                  }
                  .el-checkbox__input, .el-radio__input{
                    z-index: 0;
                    .el-checkbox__inner, .el-radio__inner{
                      width: 28px;
                      height: 28px;

                      &::after{
                        height: 15px;
                        left: 8px;
                        top: 2px;
                        width: 8px;
                        border: 3px solid #FFF;
                        border-left: 0;
                        border-top: 0;
                      }
                    }
                    .el-radio__inner{
                      &::after{
                        width: 15px;
                        height: 15px;
                        border-radius: 30px;
                        top: 50%;
                        left: 50%;
                        border-color: #fff;
                      }
                    }
                  }
                }
              }
            }
          }
          .footer{
            margin: 0 auto;
            margin-top: 20px;
            width: 200px;
            height: 45px;
            background: #E2F1FF;
            color: #0180FF;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 8px;
            cursor: pointer;
          }
        }

        .el-badge.item{
          width: 100%;
          height: 100%;

          .el-badge__content{
            border-radius: 20px;
            font-size: 16px;
            padding: 3px 8px;
            background-color: #0180FF;

            &.is-fixed{
              right: 30px;
            }
          }
        }

        button{
          width: 100%;
          height: 100%;
          border-radius: 30px;
          font-size: 18px;

          i{
            margin-left: 8px;
            font-size: 20px;
            color: #FBB30B;
          }
        }
      }
      .busca{
        width: 793px;
        height: 55px;

        .el-input{
          height: 100%;

          input{
            height: 100%;
            border-radius: 30px;
            padding-left: 45px;
            font-size: 18px;
          }

          i{
            font-size: 20px;
            color: #FBB30B;
            margin-left: 10px;
          }
        }
      }
    }

    .sem-cadastro{
      margin-top: 100px;
      width: 90%;
      margin: 100px auto;
      height: 200px;
      background: rgb(245,245,245,.3);
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      font-weight: 300;
      color: red;
      box-shadow: 1px 3px 6px rgba(0,0,0,.3);
    }

    ul.corpo-lista{
      margin: 0;
      padding: 25px 0;
      box-sizing: border-box;

      li.lista{
        width: 100%;
        height: 85px;
        padding: 0 25px;
        margin-bottom: 15px;
        border: 1px solid #CBCBCB;
        border-radius: 10px;
        box-sizing: border-box;
        cursor: pointer;
        list-style: none;
        display: flex;
        align-items: center;
        justify-content: space-between;

        &.inativo{
          .info{
            .nome-paciente{
              color: #666666;
            }
            .dados-paciente{
              color: #CBCBCB;
            }
          }
        }

        &:last-child{
          margin-bottom: 0;
        }

        .icn{
          margin-right: 25px;
        }

        .info{
          flex: 1;
          display: flex;
          height: 100%;
          flex-direction: column;
          justify-content: center;

          .nome-paciente{
            font-size: 20px;
            color: #0180FF;
            font-weight: 400;
            margin-bottom: 2px;
          }
          .dados-paciente{
            display: flex;
            font-size: 16px;
            color: #000;
            font-weight: 100;

            .cpf, .nascimento, .genero, .email{
              margin-right: 5px;
            }
          }
        }

        .acao{
          i{
            font-size: 26px;
            transform: rotate(-10deg);
            color: #0180FF;
          }
        }
      }
    }

    .paginacao{
      display: flex;
      justify-content: center;
      margin-bottom: 30px;
    }
  }
}
</style>